import * as Yup from 'yup'

export const ContractorPortalUpdateEmailModalSchema = Yup.object().shape({
  email: Yup.string().required('Email address is required').email('Email is invalid'),
})
